import { Modal, ModalBody, ModalFooter, ModalHeader } from "components/common/modal";
import { Button } from "components/common/buttons/Button";
import { BudgetRerunDiffLine } from "../budgetRerunSnapshot";
import { formatBudgetMoney } from "../formatBudgetMoney";

interface BudgetRerunDiffModalProps {
  open: boolean;
  onClose: () => void;
  diffLines: BudgetRerunDiffLine[];
  currencySymbol: string;
  beforeTotal: number;
  afterTotal: number;
}

export const BudgetRerunDiffModal = ({
  open,
  onClose,
  diffLines,
  currencySymbol,
  beforeTotal,
  afterTotal,
}: BudgetRerunDiffModalProps) => {
  const changedLines = diffLines.filter((line) => line.delta !== 0);

  return (
    <Modal isOpen={open} onClose={onClose}>
      <ModalHeader title="Rebudget changes" onClose={onClose} />
      <ModalBody>
        <div className="mb-4 text-regular-3 text-foreground/80">
          Grand total moved from {formatBudgetMoney(currencySymbol, beforeTotal, true)} to{" "}
          {formatBudgetMoney(currencySymbol, afterTotal, true)} (
          {afterTotal - beforeTotal >= 0 ? "+" : ""}
          {formatBudgetMoney(currencySymbol, afterTotal - beforeTotal, true)}).
        </div>
        {changedLines.length === 0 ? (
          <p className="text-regular-3 text-muted-foreground">
            No category-level estimate changes detected.
          </p>
        ) : (
          <div className="flex flex-col gap-2">
            {changedLines.map((line) => (
              <div
                key={line.categoryName}
                className="flex items-center justify-between rounded-lg border border-border px-3 py-2 text-regular-3"
              >
                <span className="capitalize text-foreground">{line.categoryName}</span>
                <span className={line.delta > 0 ? "text-danger" : "text-success"}>
                  {line.delta > 0 ? "+" : ""}
                  {formatBudgetMoney(currencySymbol, line.delta, true)}
                </span>
              </div>
            ))}
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button variant="ghostSecondary" onClick={onClose}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};
